import * as React from 'react';

import { TableHead } from '../components/ui/table.js';

export function DimeTableHead({ ...props }: Readonly<React.ComponentProps<typeof TableHead>>) {
  return <TableHead {...props} />;
}
